import { render, staticRenderFns } from "./RegistraScarti.vue?vue&type=template&id=23576256&scoped=true&"
import script from "./RegistraScarti.vue?vue&type=script&lang=js&"
export * from "./RegistraScarti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23576256",
  null
  
)

export default component.exports